import { pageConstatns } from "./generalConstants";
import * as skillNames from "./skillNames";
import { projects } from "./projects";

// The projectsWorkedOn will be automatically incrased depending of
// number of projects, or, in case of private projects will be
// set to 1.w

export const skills = [
  {
    name: skillNames.JavaScript,
    icon: "js",
    iconType: "png",
    experiencePercent: "87",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.JavaScript)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.ReactJs,
    icon: "react",
    iconType: "png",
    experiencePercent: "68",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.ReactJs)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.ReactApollo,
    icon: "apollo",
    iconType: "png",
    experiencePercent: "80",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.ReactApollo)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.GraphQl,
    icon: "graphql",
    iconType: "png",
    experiencePercent: "63",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.GraphQl)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.Angular,
    icon: "angular",
    iconType: "png",
    experiencePercent: "60",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.Angular)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.Git,
    icon: "git",
    iconType: "png",
    experiencePercent: "63",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.Git)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.CleanCode,
    icon: "clean",
    iconType: "png",
    experiencePercent: "70",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.CleanCode)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.TypeScript,
    icon: "ts",
    iconType: "png",
    experiencePercent: "60",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.TypeScript)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },

  {
    name: skillNames.SASS,
    icon: "sass",
    iconType: "png",
    experiencePercent: "40",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.SASS)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: true,
  },
  {
    name: skillNames.HTML,
    icon: "html",
    iconType: "png",
    experiencePercent: "90",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.HTML)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: true,
  },
  {
    name: skillNames.CSS,
    icon: "css",
    iconType: "png",
    experiencePercent: "70",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.CSS)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: true,
  },
  {
    name: skillNames.jQuery,
    icon: "jQuery",
    iconType: "png",
    experiencePercent: "70",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.jQuery)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: true,
  },
  {
    name: skillNames.p5,
    icon: "p5",
    iconType: "png",
    experiencePercent: "70",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.p5)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: true,
  },
  {
    name: skillNames.PWA_APPS,
    icon: "pwa",
    iconType: "png",
    experiencePercent: "50",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.PWA_APPS)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: true,
  },
  {
    name: skillNames.Ionic,
    icon: "ionic",
    iconType: "png",
    experiencePercent: "65",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.Ionic)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.Redux,
    icon: "redux",
    iconType: "png",
    experiencePercent: "40",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.Redux)
    ).length,
    stack: pageConstatns.frontEndStack,
    areProjectsListed: false,
  },
  {
    name: skillNames.NodeJS,
    icon: "nodejs",
    iconType: "png",
    experiencePercent: "60",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.NodeJS)
    ).length,
    stack: pageConstatns.backendStack,
  },
  {
    name: skillNames.Heroku_hosting,
    icon: "heroku",
    iconType: "png",
    experiencePercent: "",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find((skill) => skill === skillNames.Heroku_hosting)
    ).length,
    stack: pageConstatns.backendStack,
  },
  {
    name: skillNames.Firebase_DB_andnotifications,
    icon: "firebase",
    iconType: "png",
    experiencePercent: "",
    projectsWorkedOn: [...projects].filter((project) =>
      project.skills.find(
        (skill) => skill === skillNames.Firebase_DB_andnotifications
      )
    ).length,
    stack: pageConstatns.backendStack,
  },
];
